import { render, staticRenderFns } from "./CollectionHashTags.vue?vue&type=template&id=36b6538e&scoped=true&"
import script from "./CollectionHashTags.vue?vue&type=script&lang=js&"
export * from "./CollectionHashTags.vue?vue&type=script&lang=js&"
import style0 from "./CollectionHashTags.vue?vue&type=style&index=0&id=36b6538e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6538e",
  null
  
)

export default component.exports